import React from 'react';
import AASFLogo from "../media/aa-smartfuel-logo.svg";

const Tip = () => {

    const content = <>
        <div className="col-9 d-grid py-4 mb-3">
            <div className="mb-3 color-white">
                <h5 className="font-bold">Drive climate friendly with AA Smartfuel</h5>
                <p>{`You can offset your driving emissions use the AA Smartfuel app with CarbonClick as your reward to convert your discounts into carbon credits and help save the planet. You can offset your driving emissions use the AA Smartfuel app with CarbonClick as your reward to convert your discounts into carbon credits and help save the planet. You can offset your driving emissions.`}</p>
            </div>
            <div>
                <a className="btn btn-secondary btn-lg font-bold my-2 mr-2 color-black" target="_blank" href={`https://aasf.carbon.click/`}>
                    <div className="mobile-hide">
                        <div className="d-flex align-center">
                            <div className="mr-2">
                                <img style={{ height: "100%", width: "100%" }} src={AASFLogo} />
                            </div>
                            <div>
                                Join the movement
                            </div>
                        </div>
                    </div>
                    <div className="mobile-show">
                        <div>
                            Join the movement
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </>

    return (
        <div className="py-6 mobile-p-0 bg-tertiary">
            <div className="container text-center">
                <div className="mobile-hide row text-left">
                    <div className="col-3 d-grid mb-3">
                        <div className="img-cover img-1">
                        </div>
                    </div>
                    {content}
                </div>
                <div className="mobile-show row text-center">
                    {content}
                </div>
            </div>
        </div>
    );
};

export default Tip;